import { LANGUAGE } from "services/general";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  AccountsIcon,
  AdminsIcon2,
  BoxIcon,
  BuyIcon,
  CallIcon,
  CompanyIcon,
  ConIcon,
  ContactMessagesIcon,
  ControlIcon,
  EmployeeIcon,
  HumanResourcesIcon,
  IndividualIcon,
  InventoriesIcon,
  InventoryIcon,
  LedgerIcon,
  MainDataIcon,
  OppIcon,
  PermissionIcon,
  PermissionsIcon,
  PosIcon,
  PrIcon,
  ProductsIcon,
  RelationsIcon,
  ReportIcon,
  RolesIcon,
  SaleIcon,
  SupportCenterIcon2,
  ToolsIcon,
  UnitMessagesIcon,
  VouchersIcon,
  SettingIcon,
  RemindersIcon,
  InteractionsIcon,
  FavouritesIcon,
  DealsIcon,
} from "../components/shared/icons";

import {
  faAddressBook,
  faBoxOpen,
  faMoneyBillTransfer,
  faFileContract,
  faWallet,
  faUserSlash,
  faCalendarXmark,
  faHandHoldingDollar,
  faBuilding,
  faLayerGroup,
  faDatabase,
  faFileImport,
  faGaugeHigh,
  faGlobe,
  faClockRotateLeft,
  faFolderOpen,
  faFolderTree,
  faEnvelopeOpenText,
  faFileSignature,
  faFileLines,
  faTicketAlt,
  faUserGroup,
  faCalendarCheck,
  faCalendarDays,
  faCalendarWeek,
  faBullhorn,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import {
  ACTION_LOGS_INDEX,
  DOCUMENTS_INDEX,
  LETTERS_INDEX,
  ESIGN_INDEX,
  LETTERS_MANAGE_TEMPLATES,
  LETTERS_MANAGE_TYPES,
  DOCUMENT_CATEGORIES_INDEX,
  OVERVIEW_DOCUMENTS_INDEX,
  ADMINS_INDEX,
  ADVERTISEMENTS_INDEX,
  BANKS_INDEX,
  CONTRACTS_CONDITIONS_TEMPLATES_LIST,
  CONTRACTS_INDEX,
  CUSTOMERS_INDEX,
  EMPLOYEES_INDEX,
  END_OF_SERVICES_INDEX,
  PAYROLL_RUNS_INDEX,
  ATTENDANCE_INDEX,
  WORK_SHIFTS_INDEX,
  LEAVES_INDEX,
  LEAVE_TYPES_INDEX,
  EMPLOYEE_CUSTODIES_INDEX,
  EMPLOYEE_LOANS_INDEX,
  EMPLOYEES_POSITIONS_INDEX,
  DEPARTMENTS_INDEX,
  ENTITIES_INDEX,
  ACCOUNTING_PERIODS_INDEX,
  BANK_RECONCILIATIONS_INDEX,
  DOUBTFUL_DEBT_PROVISIONS_INDEX,
  FIXED_ASSETS_INDEX,
  RECEIVABLE_WRITEOFFS_INDEX,
  DEFERRAL_SCHEDULES_INDEX,
  FINANCIAL_ENTRIES_INDEX,
  FISCAL_YEAR_CLOSINGS_INDEX,
  OPENING_BALANCES_INDEX,
  RECURRING_JOURNALS_INDEX,
  FINANCIAL_TREES_INDEX,
  INVENTORIES_INDEX,
  INVENTORY_CATEGORIES_INDEX,
  INVENTORY_QUANTITY_TYPES_INDEX,
  LEADS_SOURCE_INDEX,
  PROPERTIES_INDEX,
  PO_INDEX,
  PURCHASE_INVOICES_INDEX,
  ROLES_INDEX,
  RPO_INDEX,
  PRICE_QUOTATIONS_INDEX,
  SALES_CONTRACTS_INDEX,
  SALES_INVOICES_INDEX,
  SANADAT_INDEX,
  SERVICES_INDEX,
  SITE_VISITS_INDEX,
  APPOINTMENT_BOOKINGS_INDEX,
  SERVICE_REQUESTS_INDEX,
  MAINTENANCE_INPUTS_READINGS_INDEX,
  MAINTENANCE_REQUESTS_INDEX,
  WORK_ORDERS_INDEX,
  POS_INDEX,
  SUPPORT_CENTER_TICKETS_INDEX,
  TAXES_INDEX,
  UNIT_MESSAGES_INDEX,
  VOUCHERS_DESTRUCTION_INDEX,
  VOUCHERS_RETURN_INDEX,
  VOUCHERS_SUPPLY_INDEX,
  VOUCHERS_TRANSFER_INDEX,
  VOUCHERS_WITHDRAW_INDEX,
  MAINTENANCE_SECTIONS_INDEX,
  MAINTENANCE_REVIEWS_INDEX,
  DEBIT_NOTE_INDEX,
  CREDIT_NOTE_INDEX,
  WAREHOUSES_ASSETS_INDEX,
  WAREHOUSES_EQUIPMENTS_INDEX,
  WAREHOUSES_SPAREPARTS_INDEX,
  WAREHOUSES_POS_INDEX,
  ENTITIES_TRADEMARKS_INDEX,
  LEADS_CONTACT_INDEX,
  LEADS_INDEX,
  CONTACT_MESSAGES_VIEW,
  NOTIFICATION_TEMPLATES_INDEX,
  AGENT_OPTIONS_INDEX,
  FINANCIAL_REPORTS_PERMISSIONS,
  INVENTORY_REPORTS_PERMISSIONS,
  HR_REPORTS_PERMISSIONS,
  CUSTOMER_DUES_REPORTS_PERMISSIONS,
  OWNER_VOUCHERS_REPORTS_PERMISSIONS,
  CRM_REPORTS_PERMISSIONS,
  PROPERTIES_REPORTS_PERMISSIONS,
  RENT_REPORTS_PERMISSIONS,
  SELL_REPORTS_PERMISSIONS,
  SALES_REPORTS_PERMISSIONS,
  BOOKING_REPORTS_PERMISSIONS,
  UNITS_INDEX,
  PROJECTS_INDEX,
  CUSTOMER_GLOBAL_DUES_INDEX,
  SPARE_PARTS_REQUESTS_INDEX,
  LEADS_INTERACTIONS_STORE,
  LEADS_INTERACTIONS_INDEX,
  LEADS_DEALS_INDEX,
  CRM_COMPANIES_INDEX,
  CRM_TEAMS_INDEX,
  REMINDERS_INDEX,
  LEADS_FAVOURITES_INDEX,
  OWNER_GLOBAL_DUES_INDEX,
  WITHDRAW_REQUESTS_INDEX,
  OVERVIEW_PROPERTIES_INDEX,
  OVERVIEW_FINANCE_INDEX,
  OVERVIEW_INVENTORY_INDEX,
  OVERVIEW_MAINTENANCE_INDEX,
  OVERVIEW_CUSTOMERS_INDEX,
  SERVICE_CONTRACTS_INDEX,
  BOOKING_CONTRACT_VIEW,
  EJAR_PLATFORM_CONTRACTS_INDEX,
} from "permissions";
import { HAS_PERMISSION } from "services/user";
import BellOutlined from "components/shared/svg-action-icons/BellOutlined";

export const asideLinks2 = [
  {
    text: "العقارات و الوحدات",
    en_text: "Properties & Units",
    icon: <PrIcon />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/properties`,
        id: OVERVIEW_PROPERTIES_INDEX,
      },
      {
        text: "العقارات و الوحدات",
        en_text: "Properties and Units",
        icon: <PrIcon />,
        path: `/${LANGUAGE}/units-and-properties`,
        id: HAS_PERMISSION(PROPERTIES_INDEX)
          ? PROPERTIES_INDEX
          : HAS_PERMISSION(UNITS_INDEX)
            ? UNITS_INDEX
            : PROJECTS_INDEX,
      },
      {
        text: "العقود",
        en_text: "Contracts",
        path: `/${LANGUAGE}/contracts`,
        icon: <ConIcon />,
        children: [
          {
            text: "عقود الإيجار",
            en_text: "Rent Contracts",
            path: `/${LANGUAGE}/contracts`,
            id: CONTRACTS_INDEX,
          },
          {
            text: "عقود البيع",
            en_text: "Sales Contracts",
            path: `/${LANGUAGE}/sales-contracts`,
            id: SALES_CONTRACTS_INDEX,
          },
          {
            text: "عقود الخدمات",
            en_text: "Service Contracts",
            path: `/${LANGUAGE}/service-contracts`,
            id: SERVICE_CONTRACTS_INDEX,
          },
          {
            text: "عقود الإقامة",
            en_text: "Accommodation Contracts",
            path: `/${LANGUAGE}/booking-contracts`,
            id: BOOKING_CONTRACT_VIEW,
          },
        ],
      },
      {
        text: "عقود منصة إيجار",
        en_text: "Ejar Platform Contracts",
        icon: <FontAwesomeIcon icon={faFileImport} />,
        path: `/${LANGUAGE}/ejar-contracts`,
        id: EJAR_PLATFORM_CONTRACTS_INDEX,
      },
      {
        text: "البيانات الرئيسية",
        en_text: "Master Data",
        icon: <FontAwesomeIcon icon={faDatabase} />,
        children: [
          {
            text: "الخدمات المقدمة",
            en_text: "Services",
            path: `/${LANGUAGE}/services`,
            id: SERVICES_INDEX,
          },
          {
            text: "قوالب شروط العقود",
            en_text: "Contract Conditions Templates",
            path: `/${LANGUAGE}/contracts-conditions`,
            id: CONTRACTS_CONDITIONS_TEMPLATES_LIST,
          },
        ],
      },
    ],
  },
  {
    text: "المالية",
    en_text: "Finance",
    icon: <AccountsIcon />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/finance`,
        id: OVERVIEW_FINANCE_INDEX,
      },
      {
        text: "المبيعات",
        en_text: "Sales",
        icon: <SaleIcon />,
        children: [
          {
            text: "فواتير",
            en_text: "Invoices",
            path: `/${LANGUAGE}/sales-invoices`,
            id: SALES_INVOICES_INDEX,
          },
          {
            text: "عروض الأسعار",
            en_text: "Price Quotations",
            path: `/${LANGUAGE}/price-quotations`,
            id: PRICE_QUOTATIONS_INDEX,
          },
          {
            text: "إشعار دائن",
            en_text: "Credit Note",
            path: `/${LANGUAGE}/credit-notes`,
            id: CREDIT_NOTE_INDEX,
          },
        ],
      },
      {
        text: "القيود المالية",
        en_text: "Ledger",
        icon: <LedgerIcon />,
        path: `/${LANGUAGE}/financial-entries`,
        id: FINANCIAL_ENTRIES_INDEX,
      },
      {
        text: "الإقفال المحاسبي",
        en_text: "Period Close",
        icon: <LedgerIcon />,
        children: [
          {
            text: "الفترات المحاسبية",
            en_text: "Accounting Periods",
            path: `/${LANGUAGE}/accounting-periods`,
            id: ACCOUNTING_PERIODS_INDEX,
          },
          {
            text: "إقفال السنة المالية",
            en_text: "Year-End Close",
            path: `/${LANGUAGE}/fiscal-year-closings`,
            id: FISCAL_YEAR_CLOSINGS_INDEX,
          },
          {
            text: "الأرصدة الافتتاحية",
            en_text: "Opening Balances",
            path: `/${LANGUAGE}/opening-balances`,
            id: OPENING_BALANCES_INDEX,
          },
          {
            text: "القيود الدورية",
            en_text: "Recurring Journals",
            path: `/${LANGUAGE}/recurring-journals`,
            id: RECURRING_JOURNALS_INDEX,
          },
          {
            text: "جداول الاستحقاق",
            en_text: "Deferral Schedules",
            path: `/${LANGUAGE}/deferral-schedules`,
            id: DEFERRAL_SCHEDULES_INDEX,
          },
          {
            text: "الأصول الثابتة",
            en_text: "Fixed Assets",
            path: `/${LANGUAGE}/fixed-assets`,
            id: FIXED_ASSETS_INDEX,
          },
          {
            text: "التسويات البنكية",
            en_text: "Bank Reconciliation",
            path: `/${LANGUAGE}/bank-reconciliations`,
            id: BANK_RECONCILIATIONS_INDEX,
          },
          {
            text: "مخصص الديون المشكوك فيها",
            en_text: "Doubtful Debt Provision",
            path: `/${LANGUAGE}/doubtful-debt-provisions`,
            id: DOUBTFUL_DEBT_PROVISIONS_INDEX,
          },
          {
            text: "إعدام الديون",
            en_text: "Receivable Write-Offs",
            path: `/${LANGUAGE}/receivable-writeoffs`,
            id: RECEIVABLE_WRITEOFFS_INDEX,
          },
        ],
      },
      {
        text: "المشتريات",
        en_text: "Purchases",
        icon: <BuyIcon />,
        children: [
          {
            text: "فواتير",
            en_text: "Invoices",
            path: `/${LANGUAGE}/purchase-invoices`,
            id: PURCHASE_INVOICES_INDEX,
          },
          {
            text: "إشعار مدين",
            en_text: "Debit Note",
            path: `/${LANGUAGE}/debit-notes`,
            id: DEBIT_NOTE_INDEX,
          },
          {
            text: "طلب شراء",
            en_text: "Purchase Request",
            path: `/${LANGUAGE}/rpos`,
            id: RPO_INDEX,
          },
          {
            text: "أمر شراء",
            en_text: "Purchase Order",
            path: `/${LANGUAGE}/purchase-orders`,
            id: PO_INDEX,
          },
        ],
      },
      {
        text: "السندات",
        en_text: "Vouchers",
        icon: <VouchersIcon />,
        path: `/${LANGUAGE}/vouchers`,
        id: SANADAT_INDEX,
      },
      {
        text: "المستحقات",
        en_text: "Dues",
        icon: <VouchersIcon />,
        children: [
          {
            text: "مستحقات العملاء",
            en_text: "Customer Dues",
            path: `/${LANGUAGE}/dues?due_type=customer`,
            id: CUSTOMER_GLOBAL_DUES_INDEX,
          },
          {
            text: "مستحقات الملاك",
            en_text: "Owner Dues",
            path: `/${LANGUAGE}/dues?due_type=owner`,
            id: OWNER_GLOBAL_DUES_INDEX,
          },
        ],
      },
      {
        text: "البيانات الرئيسية",
        en_text: "Master Data",
        icon: <MainDataIcon />,
        children: [
          {
            text: "الحسابات البنكية",
            en_text: "Banks Accounts",
            path: `/${LANGUAGE}/banks`,
            id: BANKS_INDEX,
          },
          {
            text: "الضرائب والرسوم",
            en_text: "Taxes & Fees",
            path: `/${LANGUAGE}/taxes`,
            id: TAXES_INDEX,
          },
          {
            text: "شجرة الحسابات",
            en_text: "Financial Tree",
            path: `/${LANGUAGE}/financial-trees`,
            id: FINANCIAL_TREES_INDEX,
          },
          {
            text: "الكيانات والموردون",
            en_text: "Entities and Suppliers",
            path: `/${LANGUAGE}/entities`,
            // icon: <EntitiesIcon />,
            id: ENTITIES_INDEX,
          },
        ],
      },
    ],
  },
  {
    text: "العملاء",
    en_text: "Customers",
    icon: <RelationsIcon />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/customers`,
        id: OVERVIEW_CUSTOMERS_INDEX,
      },
      {
        text: "الأفراد",
        en_text: "Individuals",
        path: `/${LANGUAGE}/customers?customer_type=individual`,
        icon: <IndividualIcon />,
        id: CUSTOMERS_INDEX,
      },
      {
        text: "الشركات",
        en_text: "Companies",
        path: `/${LANGUAGE}/customers?customer_type=company`,
        icon: <CompanyIcon />,
        id: CUSTOMERS_INDEX,
      },
      {
        // Tickets raised from the mobile app by tenants and owners — people who are
        // already on the books, which is why this sits with the customer directory and
        // not in CRM. Nothing here feeds the sales funnel; it is what someone you have
        // already signed is asking you for.
        text: "مركز الدعم الفني",
        en_text: "Support Center",
        path: `/${LANGUAGE}/support-center`,
        id: SUPPORT_CENTER_TICKETS_INDEX,
        icon: <SupportCenterIcon2 />,
      },
    ],
  },
  {
    text: "المخازن",
    en_text: "Inventories",
    icon: <InventoriesIcon />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/inventory`,
        id: OVERVIEW_INVENTORY_INDEX,
      },
      {
        text: "المنتجات",
        en_text: "Products",
        icon: <ProductsIcon />,
        path: `/${LANGUAGE}/products`,
        id: INVENTORIES_INDEX,
      },
      {
        text: "مستويات المخزون",
        en_text: "Stock Levels",
        icon: <FontAwesomeIcon icon={faLayerGroup} />,
        path: `/${LANGUAGE}/stock-levels`,
        id: INVENTORIES_INDEX,
      },
      {
        text: "نقاط البيع",
        en_text: "POS",
        path: `/${LANGUAGE}/pos`,
        icon: <PosIcon />,
        id: POS_INDEX,
      },
      {
        text: "طلبات السحب",
        en_text: "Withdraw Requests",
        path: `/${LANGUAGE}/stock-withdraw-requests`,
        icon: <FontAwesomeIcon icon={faBoxOpen} />,
        id: WITHDRAW_REQUESTS_INDEX,
      },
      {
        text: "المستودعات",
        en_text: "Warehouses",
        icon: <InventoryIcon />,
        path: `/${LANGUAGE}/warehouses`,
        children: [
          {
            text: "الأصول والممتلكات",
            en_text: "Assets",
            path: `/${LANGUAGE}/warehouses/assets`,
            id: WAREHOUSES_ASSETS_INDEX,
          },
          {
            text: "المعدات",
            en_text: "Equipments",
            path: `/${LANGUAGE}/warehouses/equipments`,
            id: WAREHOUSES_EQUIPMENTS_INDEX,
          },
          {
            text: "قطع الغيار",
            en_text: "Spare-parts",
            path: `/${LANGUAGE}/warehouses/spareparts`,
            id: WAREHOUSES_SPAREPARTS_INDEX,
          },
          {
            text: "نقاط البيع",
            en_text: "POS",
            path: `/${LANGUAGE}/warehouses/pos`,
            id: WAREHOUSES_POS_INDEX,
          },
        ],
      },

      {
        text: "اذونات المخازن",
        en_text: "Inventory Vouchers",
        icon: <PermissionIcon />,
        children: [
          {
            text: "إذن صرف مخزون",
            en_text: "Withdraw Voucher",
            path: `/${LANGUAGE}/inventory-vouchers/withdraw`,
            id: VOUCHERS_WITHDRAW_INDEX,
          },
          {
            text: "إذن استلام مخزون",
            en_text: "Supply Voucher",
            path: `/${LANGUAGE}/inventory-vouchers/supply`,
            id: VOUCHERS_SUPPLY_INDEX,
          },
          {
            text: "إذن إرجاع مخزون",
            en_text: "Return Voucher",
            path: `/${LANGUAGE}/inventory-vouchers/return`,
            id: VOUCHERS_RETURN_INDEX,
          },
          {
            text: "إذن نقل مخزون",
            en_text: "Transfer Voucher",
            path: `/${LANGUAGE}/inventory-vouchers/transfer`,
            id: VOUCHERS_TRANSFER_INDEX,
          },
          {
            text: "إذن إهلاك مخزون",
            en_text: "Destruction Voucher",
            path: `/${LANGUAGE}/inventory-vouchers/destruction`,
            id: VOUCHERS_DESTRUCTION_INDEX,
          },
        ],
      },

      {
        text: "البيانات الرئيسية",
        en_text: "Master Data",
        icon: <MainDataIcon />,
        children: [
          {
            text: "العلامات والطرازات",
            en_text: "Trademarks & Models",
            path: `/${LANGUAGE}/entities-trademarks`,
            id: ENTITIES_TRADEMARKS_INDEX,
          },
          {
            text: "تصنيفات المنتجات",
            en_text: "Inventory Categories",
            path: `/${LANGUAGE}/inventory-categories`,
            id: INVENTORY_CATEGORIES_INDEX,
          },
          {
            text: "وحدات القياس",
            en_text: "Units of Measurement",
            path: `/${LANGUAGE}/inventory-types`,
            id: INVENTORY_QUANTITY_TYPES_INDEX,
          },
        ],
      },
    ],
  },
  {
    text: "الموارد البشرية",
    en_text: "HR",
    icon: <HumanResourcesIcon />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/hr`,
        // The employees register's own key: the page is a view over registers
        // that permission already opens, and there is no overview.hr key yet.
        id: EMPLOYEES_INDEX,
      },
      {
        text: "الموظفين",
        en_text: "Employees",
        icon: <EmployeeIcon />,
        path: `/${LANGUAGE}/employees`,
        id: EMPLOYEES_INDEX,
      },
      {
        text: "مسيرات الرواتب",
        en_text: "Payroll",
        icon: <FontAwesomeIcon icon={faMoneyBillTransfer} />,
        path: `/${LANGUAGE}/payroll-runs`,
        id: PAYROLL_RUNS_INDEX,
      },
      {
        text: "نهاية الخدمة",
        en_text: "End of Service",
        icon: <FontAwesomeIcon icon={faUserSlash} />,
        path: `/${LANGUAGE}/end-of-services`,
        id: END_OF_SERVICES_INDEX,
      },
      {
        text: "العقود المنتهية",
        en_text: "Expiring Contracts",
        icon: <FontAwesomeIcon icon={faFileContract} />,
        path: `/${LANGUAGE}/employee-contracts`,
        id: EMPLOYEES_INDEX,
      },
      {
        text: "الحضور والانصراف",
        en_text: "Attendance",
        icon: <FontAwesomeIcon icon={faCalendarCheck} />,
        path: `/${LANGUAGE}/attendance`,
        id: ATTENDANCE_INDEX,
      },
      {
        text: "الإجازات",
        en_text: "Leave",
        icon: <FontAwesomeIcon icon={faCalendarXmark} />,
        path: `/${LANGUAGE}/leaves`,
        id: LEAVES_INDEX,
      },
      {
        text: "سلف الموظفين",
        en_text: "Employee Advances",
        icon: <FontAwesomeIcon icon={faHandHoldingDollar} />,
        path: `/${LANGUAGE}/employee-loans`,
        id: EMPLOYEE_LOANS_INDEX,
      },
      {
        // Beside Advances on purpose: they are the two registers an office
        // confuses, and seeing them next to each other is what makes the
        // difference legible.
        text: "عهد الموظفين",
        en_text: "Employee Custody",
        icon: <FontAwesomeIcon icon={faWallet} />,
        path: `/${LANGUAGE}/employee-custodies`,
        id: EMPLOYEE_CUSTODIES_INDEX,
      },
      /*{
        text: "سجل الرواتب",
        en_text: "Payouts",
        icon: <PayoutIcon />,
        path: `/${LANGUAGE}/payouts`,
        id: null,
      },*/
      // {
      //   text: "الحضور والأنصراف",
      //   en_text: "Attendance & Departure",

      //   children: [
      //     {
      //       text: "الخصومات",
      //       en_text: "HR Deductions",
      //       path: `/${LANGUAGE}/hr-deductions`,
      //       id: 61, // to do
      //     },
      //   ],
      // },
      {
        text: "البيانات الرئيسية",
        en_text: "Master Data",
        icon: <MainDataIcon />,
        children: [
          {
            text: "الإدارات",
            en_text: "Departments",
            path: `/${LANGUAGE}/departments`,
            id: DEPARTMENTS_INDEX,
          },
          {
            text: "المسميات الوظيفية",
            en_text: "Job Titles",
            path: `/${LANGUAGE}/employee-positions`,
            id: EMPLOYEES_POSITIONS_INDEX,
          },
          {
            text: "ورديات العمل",
            en_text: "Work Shifts",
            path: `/${LANGUAGE}/work-shifts`,
            id: WORK_SHIFTS_INDEX,
          },
          {
            text: "أنواع الإجازات",
            en_text: "Leave Types",
            path: `/${LANGUAGE}/leave-types`,
            id: LEAVE_TYPES_INDEX,
          },
        ],
      },
    ],
  },
  {
    text: "مدراء النظام",
    en_text: "Administrators",
    icon: <PermissionsIcon />,
    children: [
      {
        text: "الحسابات",
        en_text: "Accounts",
        path: `/${LANGUAGE}/admins`,
        id: ADMINS_INDEX,
        icon: <AdminsIcon2 />,
      },
      {
        text: "الأدوار والمسؤوليات",
        en_text: "Roles & Responsibilities",
        path: `/${LANGUAGE}/admin/roles`,
        id: ROLES_INDEX,
        icon: <RolesIcon />,
      },
      {
        // Sits with the accounts and roles it reports on: this is the screen
        // that shows what the users created there have been doing.
        text: "سجل عمليات المستخدمين",
        en_text: "User Activity Log",
        path: `/${LANGUAGE}/action-logs`,
        id: ACTION_LOGS_INDEX,
        icon: <FontAwesomeIcon icon={faClockRotateLeft} />,
      },
    ],
  },
  {
    // Its own group rather than a leaf under Administrators or Settings: the
    // register is a working screen an office visits weekly to renew things, not a
    // configuration surface. The categories screen sits under it because it is the
    // filing scheme *for* the register — and it carries its own permission, so a
    // role that uploads documents need not be able to redefine what is mandatory.
    text: "إدارة الوثائق",
    en_text: "Document Control",
    icon: <FontAwesomeIcon icon={faFolderOpen} />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/documents`,
        id: OVERVIEW_DOCUMENTS_INDEX,
      },
      {
        text: "سجل الوثائق",
        en_text: "Document Register",
        path: `/${LANGUAGE}/documents`,
        id: DOCUMENTS_INDEX,
        icon: <FontAwesomeIcon icon={faFolderOpen} />,
      },
      {
        text: "التصنيفات",
        en_text: "Categories",
        path: `/${LANGUAGE}/document-categories`,
        id: DOCUMENT_CATEGORIES_INDEX,
        icon: <FontAwesomeIcon icon={faFolderTree} />,
      },
    ],
  },
  {
    // Official correspondence: the register, the reusable templates behind it,
    // and the filing types. Each leaf carries its own permission, so a role
    // that writes letters need not be able to rewrite the office's templates.
    text: "الخطابات",
    en_text: "Letters",
    icon: <FontAwesomeIcon icon={faEnvelopeOpenText} />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/letters`,
        id: LETTERS_INDEX,
      },
      {
        text: "سجل الخطابات",
        en_text: "Letters Register",
        path: `/${LANGUAGE}/letters`,
        id: LETTERS_INDEX,
        icon: <FontAwesomeIcon icon={faEnvelopeOpenText} />,
      },
      {
        text: "قوالب الخطابات",
        en_text: "Letter Templates",
        path: `/${LANGUAGE}/letter-templates`,
        id: LETTERS_MANAGE_TEMPLATES,
        icon: <FontAwesomeIcon icon={faFileLines} />,
      },
      {
        text: "تصنيفات الخطابات",
        en_text: "Letter Types",
        path: `/${LANGUAGE}/letter-types`,
        id: LETTERS_MANAGE_TYPES,
        icon: <FontAwesomeIcon icon={faFolderTree} />,
      },
    ],
  },
  {
    // Its own group rather than a leaf under Letters or Document Control: a
    // signature request is raised from a contract, a letter or an uploaded
    // file, so filing it under any one of them would hide it from the other
    // two. One leaf today; the register is the whole module.
    text: "التوقيع الإلكتروني",
    en_text: "Electronic Signature",
    icon: <FontAwesomeIcon icon={faFileSignature} />,
    children: [
      {
        text: "طلبات التوقيع",
        en_text: "Signature Requests",
        path: `/${LANGUAGE}/esign-requests`,
        id: ESIGN_INDEX,
        icon: <FontAwesomeIcon icon={faFileSignature} />,
      },
    ],
  },
  {
    text: "إدارة علاقة العملاء",
    en_text: "CRM",
    icon: <RelationsIcon />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        path: `/${LANGUAGE}/crm/my-dashboard`,
        icon: <RemindersIcon />,
        // `public` rather than a permission id: this is the agent's own dashboard and
        // every zone inside it is gated separately by the module it summarises, so
        // hiding the entry would only cost an agent the way in to their own work.
        public: true,
      },
      {
        text: "الفرص المحتملة",
        en_text: "Potential Opportunities",
        path: `/${LANGUAGE}/crm/potential-customers`,
        id: LEADS_INDEX,
        icon: <OppIcon />,
      },
      {
        // Directly after the funnel it comes out of: a deal is what a qualified
        // opportunity becomes, so the two read in the order the work happens.
        text: "الصفقات",
        en_text: "Deals",
        path: `/${LANGUAGE}/deals`,
        id: LEADS_DEALS_INDEX,
        icon: <DealsIcon />,
      },
      {
        text: "التذكيرات",
        en_text: "Reminders",
        path: `/${LANGUAGE}/reminders`,
        id: REMINDERS_INDEX,
        icon: <RemindersIcon />,
      },
      {
        text: "المفضلة",
        en_text: "Favourites",
        path: `/${LANGUAGE}/favourites`,
        id: LEADS_FAVOURITES_INDEX,
        icon: <FavouritesIcon />,
      },
      {
        text: "سجل التفاعلات",
        en_text: "Interactions",
        path: `/${LANGUAGE}/interactions`,
        id: LEADS_INTERACTIONS_INDEX,
        icon: <InteractionsIcon />,
      },
      {
        // The records a salesperson picks *from* rather than works: the contacts,
        // companies, teams and channels the funnel refers to. Grouped and placed last,
        // the way every other module's Master Data is, so the CRM list reads as the
        // work first and its reference data after.
        text: "البيانات الرئيسية",
        en_text: "Master Data",
        icon: <MainDataIcon />,
        children: [
          {
            text: "جهات الاتصال",
            en_text: "Contacts",
            path: `/${LANGUAGE}/crm/contacts`,
            id: LEADS_CONTACT_INDEX,
            icon: <FontAwesomeIcon icon={faAddressBook} />,
          },
          {
            text: "الشركات",
            en_text: "Companies",
            path: `/${LANGUAGE}/crm/companies`,
            id: CRM_COMPANIES_INDEX,
            icon: <FontAwesomeIcon icon={faBuilding} />,
          },
          {
            text: "فرق المبيعات",
            en_text: "Sales Teams",
            path: `/${LANGUAGE}/crm/teams`,
            id: CRM_TEAMS_INDEX,
            // The same glyph the assign dialog and the team card use, so "team" reads
            // as one thing across the app.
            icon: <FontAwesomeIcon icon={faUserGroup} />,
          },
          {
            text: "قنوات الوصول",
            en_text: "Lead Channels",
            path: `/${LANGUAGE}/leads-sources`,
            id: LEADS_SOURCE_INDEX,
            icon: <CallIcon />,
          },
        ],
      },
      // {
      //   text: "التقارير",
      //   en_text: "Reports",
      //   path: `/${LANGUAGE}/crm/reports`,
      //   id: 158,
      // },
    ],
  },
  {
    // The two public-site inboxes. Both are written by strangers — a property seeker
    // asking about a listing, a visitor asking about a service — so neither is about
    // anyone on the books, and neither is CRM: they are the raw demand a lead is made
    // *from*, not the funnel being worked. Kept together because they behave
    // identically, and named after where they come from rather than what they are
    // about, which is the only thing true of both.
    text: "الموقع التسويقي",
    en_text: "Marketing Website",
    icon: <FontAwesomeIcon icon={faGlobe} />,
    children: [
      {
        text: "الإعلانات المنشورة",
        en_text: "Published Listings",
        path: `/${LANGUAGE}/advertisements`,
        icon: <FontAwesomeIcon icon={faBullhorn} />,
        id: ADVERTISEMENTS_INDEX,
      },
      {
        text: "رسائل الأهتمام",
        en_text: "Leads Messages",
        path: `/${LANGUAGE}/units-messages`,
        id: UNIT_MESSAGES_INDEX,
        icon: <UnitMessagesIcon />,
      },
      {
        text: "رسائل اتصل بنا",
        en_text: "Contact Us Messages",
        path: `/${LANGUAGE}/contact-messages`,
        id: CONTACT_MESSAGES_VIEW,
        icon: <ContactMessagesIcon />,
      },
      {
        text: "مواعيد المعاينة",
        en_text: "Site Visits",
        path: `/${LANGUAGE}/site-visit-booking`,
        id: SITE_VISITS_INDEX,
        icon: <FontAwesomeIcon icon={faCalendarCheck} />,
      },
      {
        text: "حجوزات المواعيد",
        en_text: "Appointment Bookings",
        path: `/${LANGUAGE}/appointment-bookings`,
        id: APPOINTMENT_BOOKINGS_INDEX,
        icon: <FontAwesomeIcon icon={faCalendarDays} />,
      }, {
        text: "طلبات الخدمات",
        en_text: "Service Requests",
        path: `/${LANGUAGE}/service-requests`,
        id: SERVICE_REQUESTS_INDEX,
        icon: <FontAwesomeIcon icon={faClipboardList} />,
      },
    ],
  },
  {
    text: "إدارة الصيانة",
    en_text: "Maintenance",
    icon: <ControlIcon />,
    children: [
      {
        text: "نظرة عامة",
        en_text: "Overview",
        icon: <FontAwesomeIcon icon={faGaugeHigh} />,
        path: `/${LANGUAGE}/overview/maintenance`,
        id: OVERVIEW_MAINTENANCE_INDEX,
      },
      {
        text: "البلاغات",
        en_text: "Maintenance Requests",
        path: `/${LANGUAGE}/maintenance/requests`,
        id: MAINTENANCE_REQUESTS_INDEX,
        icon: <FontAwesomeIcon icon={faTicketAlt} />,
      },
      {
        text: "أوامر العمل",
        en_text: "Work Orders",
        path: `/${LANGUAGE}/maintenance/work-orders`,
        id: WORK_ORDERS_INDEX,
        icon: <ToolsIcon />,
      },
      {
        text: "عبء عمل الفنيين",
        en_text: "Technician Workload",
        path: `/${LANGUAGE}/maintenance/technicians-workload`,
        id: WORK_ORDERS_INDEX,
        icon: <FontAwesomeIcon icon={faCalendarWeek} />,
      },
      {
        text: "طلبات قطع الغيار",
        en_text: "Spare Parts Requests",
        path: `/${LANGUAGE}/spareparts-requests`,
        id: SPARE_PARTS_REQUESTS_INDEX,
        icon: <BoxIcon />,
      },
      {
        text: "البيانات الرئيسية",
        en_text: "Master Data",
        icon: <MainDataIcon />,
        children: [
          {
            text: "التصنيفات",
            en_text: "Categories",
            path: `/${LANGUAGE}/maintenance/sections`,
            id: MAINTENANCE_SECTIONS_INDEX,
          },
          {
            text: "قوائم المراجعات",
            en_text: "Checklist Items",
            path: `/${LANGUAGE}/maintenance/reviews`,
            id: MAINTENANCE_REVIEWS_INDEX,
          },
          {
            text: "المدخلات والقراءات",
            en_text: "Inputs & Readings",
            path: `/${LANGUAGE}/maintenance/inputs-readings`,
            id: MAINTENANCE_INPUTS_READINGS_INDEX,
          },
        ],
      },
    ],
  },
  {
    text: "التقارير",
    en_text: "Reports",
    icon: <ReportIcon />,
    children: [
      {
        text: "التقارير المالية",
        en_text: "Financial Reports",
        path: `/${LANGUAGE}/reports/financial`,
        ids: FINANCIAL_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير المخزون",
        en_text: "Inventory Reports",
        path: `/${LANGUAGE}/reports/inventory-reports`,
        ids: INVENTORY_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير الموارد البشرية",
        en_text: "HR Reports",
        path: `/${LANGUAGE}/reports/hr`,
        ids: HR_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "مديونيات العملاء والتحصيل",
        en_text: "Customer Dues & Collections",
        path: `/${LANGUAGE}/reports/customer-dues`,
        ids: CUSTOMER_DUES_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "الملاك والسندات",
        en_text: "Owner & Vouchers",
        path: `/${LANGUAGE}/reports/owner-vouchers`,
        ids: OWNER_VOUCHERS_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير CRM",
        en_text: "CRM Reports",
        path: `/${LANGUAGE}/reports/crm-reports`,
        ids: CRM_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير العقارات والوحدات",
        en_text: "Properties & Units",
        path: `/${LANGUAGE}/reports/properties`,
        ids: PROPERTIES_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير عقود الإيجار",
        en_text: "Rent Contracts",
        path: `/${LANGUAGE}/reports/rent`,
        ids: RENT_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير عقود البيع",
        en_text: "Sell Contracts",
        path: `/${LANGUAGE}/reports/sell`,
        ids: SELL_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير عقود الإقامة",
        en_text: "Accommodation Contracts",
        path: `/${LANGUAGE}/reports/booking`,
        ids: BOOKING_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
      {
        text: "تقارير المبيعات وعروض الأسعار",
        en_text: "Sales & Quotations",
        path: `/${LANGUAGE}/reports/sales`,
        ids: SALES_REPORTS_PERMISSIONS,
        icon: <ReportIcon />,
      },
    ],
  },
  {
    text: "الإعدادات",
    en_text: "Settings",
    icon: <SettingIcon />,
    children: [
      {
        text: "الإعدادات",
        en_text: "Settings",
        path: `/${LANGUAGE}/settings`,
        id: AGENT_OPTIONS_INDEX,
        icon: <SettingIcon />,
      },
      {
        text: "قوالب الإشعارات",
        en_text: "Notification Templates",
        path: `/${LANGUAGE}/notification-templates`,
        icon: <BellOutlined />,
        id: NOTIFICATION_TEMPLATES_INDEX,
      },
    ],
  },
];
